import { VectorTile } from '@mapbox/vector-tile'
import { Feature } from 'geojson'
import Protobuf from 'pbf'
import { TileAddress } from './types'

export const decodeMVT = (data: ArrayBuffer): VectorTile => {
  // Convert ArrayBuffer → Uint8Array (what Protobuf expects)
  const buffer = new Uint8Array(data)
  const tile = new VectorTile(new Protobuf(buffer))
  return tile
}

export const getTileLayerFeatures = (
  data: ArrayBuffer,
  layerName: string,
  address: TileAddress
): Feature[] => {
  const tile = decodeMVT(data)

  const features: Feature[] = []
  const featureCount = tile.layers[layerName]?.length || 0

  for (let i = 0; i < featureCount; i++) {
    const feature = tile.layers[layerName].feature(i).toGeoJSON(address.x, address.y, address.z)

    features.push(feature)
  }

  return features as Feature[]
}
